export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://localhost:7221/api",
  ENDPOINTS: {
    CAREHOMES: "/carehomes",
    CUSTOMERS: "/customers",
    CUSTOMER_LINK: "/customers/link",
    CUSTOMER_LINK_BY_TOKEN: "/customers/link/{token}",
    CUSTOMERS_PRECHECK: "/customers/precheck",
    CHECK_CONVERSION_STATUS: "/checkconversionstatus",
    POSTCODE_SEARCH: "/postcodes/search",
    POSTCODE_DETAILS: "/postcodes",
    RESOLVE_LEGACY_CUSTOMER: "/mapping/resolve-legacy",
    RESOLVE_LEGACY_IDS: "/mapping/legacyids",
    FORCE_SYNC: "/customers/{id}/force-sync",
    DUPLICATE_AUDITS: "/duplicate-audits",
    DUPLICATE_AUDIT_LOOKUPS: "/duplicate-audits/lookups",
    DUPLICATE_AUDIT_REVIEW: "/duplicate-audits/{id}/review",
  },
};

export const NAVIGATION_CONFIG = {
  // Path segments for nested routes (relative to parent) - SOURCE OF TRUTH
  PATH_SEGMENTS: {
    CUSTOMERS: "customers",
    CUSTOMERS_WITH_ID: "customers/:id", 
    CARE_HOMES: "care-homes",
    CARE_HOMES_WITH_ID: "care-homes/:id",
    CUSTOMERS_LEGACY: "customers/legacy/:systemName/:localCustomerId",
    MANAGER_DUPLICATE_AUDITS: "manager/duplicate-audits",
  },
  // Full route paths built from segments (for navigation calls)
  get ROUTES() {
    return {
      HOME: "/",
      CUSTOMERS: `/${this.PATH_SEGMENTS.CUSTOMERS}`,
      CUSTOMERS_DETAIL: `/${this.PATH_SEGMENTS.CUSTOMERS_WITH_ID}`,
      CUSTOMERS_NEW: `/${this.PATH_SEGMENTS.CUSTOMERS}/new`,
      CARE_HOMES: `/${this.PATH_SEGMENTS.CARE_HOMES}`,
      CARE_HOMES_DETAIL: `/${this.PATH_SEGMENTS.CARE_HOMES_WITH_ID}`,
      CARE_HOMES_NEW: `/${this.PATH_SEGMENTS.CARE_HOMES}/new`,
      CUSTOMERS_LEGACY_REDIRECT: `/${this.PATH_SEGMENTS.CUSTOMERS_LEGACY}`,
      MANAGER_DUPLICATE_AUDITS: `/${this.PATH_SEGMENTS.MANAGER_DUPLICATE_AUDITS}`,
      SIGNIN: "/signin",
    };
  },
  // Helper functions to generate dynamic routes
  getCustomerDetailRoute: (id: string) => `/${NAVIGATION_CONFIG.PATH_SEGMENTS.CUSTOMERS}/${id}`,
  getCareHomeDetailRoute: (id: string) => `/${NAVIGATION_CONFIG.PATH_SEGMENTS.CARE_HOMES}/${id}`,
  getLegacyCustomerRoute: (systemName: string, localCustomerId: string) => 
    `/${NAVIGATION_CONFIG.PATH_SEGMENTS.CUSTOMERS}/legacy/${systemName}/${localCustomerId}`,
};

export const TITLE_OPTIONS = [
  "Mr",
  "Mrs",
  "Miss",
  "Ms",
  "Dr",
  "Prof",
  "Rev",
  "Sir",
  "Lady",
  "Lord",
];

export const getApiUrl = (endpoint: string, id?: string | number) => {
  return id
    ? `${API_CONFIG.BASE_URL}${endpoint}/${id}`
    : `${API_CONFIG.BASE_URL}${endpoint}`;
};
